import { useQuery } from '@tanstack/react-query'
import { callContract } from '../contractClient'
import { contracts } from '../../../../shared/features/platform.contracts'

const POLL_INTERVAL_MS = 30_000

export const SYSTEM_HEALTH_QUERY_KEY = ['platform', 'system-health']

const EMPTY_STATE = {
  state: 'ok',
  counts: { total: 0, healthy: 0, degraded: 0 },
  degraded_summary: [],
  groups: [],
  generated_at: null,
}

/**
 * System health through the shared query client: every HealthMenu on the
 * page shares one request every 30 seconds, and the interval never fires
 * while the browser tab is hidden.
 */
export default function useSystemHealth() {
  const { data, isPending, error, refetch } = useQuery({
    queryKey: SYSTEM_HEALTH_QUERY_KEY,
    queryFn: async () => {
      const response = await callContract(contracts.systemHealth)
      return response.data || EMPTY_STATE
    },
    staleTime: POLL_INTERVAL_MS,
    refetchInterval: POLL_INTERVAL_MS,
  })

  return {
    health: data ?? EMPTY_STATE,
    loading: isPending,
    error: error ? (error.response?.data?.error || error.message || 'Failed to load system health') : null,
    refresh: refetch,
  }
}
